/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {HtmlParser} from '../ml_parser/html_parser';
import {InterpolationConfig} from '../ml_parser/interpolation_config';
import {ParseError} from '../parse_util';

import {extractMessages} from './extractor_merger';
import {Message} from './i18n_ast';
import {Serializer} from './serializers/serializer';
/**
 *  A container for message extracted from the templates.
 */
export class MessageBundle {
private _messages: Message[] = [];
/**
 * @param {?} _htmlParser
 * @param {?} _implicitTags
 * @param {?} _implicitAttrs
 */
constructor(
private _htmlParser: HtmlParser,
private _implicitTags: string[],
private _implicitAttrs: {[k: string]: string[]}) {}
/**
 * @param {?} html
 * @param {?} url
 * @param {?} interpolationConfig
 * @return {?}
 */
updateFromTemplate(html: string, url: string, interpolationConfig: InterpolationConfig):
      ParseError[] {
    const /** @type {?} */ htmlParserResult = this._htmlParser.parse(html, url, true, interpolationConfig);

    if (htmlParserResult.errors.length) {
      return htmlParserResult.errors;
    }

    const /** @type {?} */ i18nParserResult = extractMessages(
        htmlParserResult.rootNodes, interpolationConfig, this._implicitTags, this._implicitAttrs);

    if (i18nParserResult.errors.length) {
      return i18nParserResult.errors;
    }

    this._messages.push(...i18nParserResult.messages);
  }
/**
 * @return {?}
 */
getMessages(): Message[] { return this._messages; }
/**
 * @param {?} serializer
 * @return {?}
 */
write(serializer: Serializer): string { return serializer.write(this._messages); }
}

function MessageBundle_tsickle_Closure_declarations() {
 /** @type {?} */
MessageBundle.prototype._messages;
 /** @type {?} */
MessageBundle.prototype._htmlParser;
 /** @type {?} */
MessageBundle.prototype._implicitTags;
 /** @type {?} */
MessageBundle.prototype._implicitAttrs;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
